import {
  Tooltip,
  ToggleButton,
  ToggleButtonGroup as MUIToggleButtonGroup,
  toggleButtonGroupClasses,
} from '@mui/material';
import type { SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode, MouseEvent } from 'react';

const StyledToggleButtonGroup = styled(MUIToggleButtonGroup)(() => ({
  [`& .${toggleButtonGroupClasses.middleButton}, & .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: 0,
    },
}));
const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  textTransform: 'none',

  '&.Mui-selected': {
    color: '#063FFE',
    backgroundColor: '#EBEFFF',
  },

  '&.Mui-disabled': {
    pointerEvents: 'auto',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

interface Props {
  fullWidth?: boolean;
  slotProps?: {
    optionButton?: {
      sx?: SxProps;
    };
  };
  options: {
    label: ReactNode;
    value: any;
    title?: string;
    disabled?: boolean;
    tooltip?: string;
  }[];
  value?: any;
  optionSx?: SxProps;
  onChange: (value: any) => void;
}

export function ToggleButtonGroup({
  fullWidth,
  slotProps,
  options,
  value,
  onChange,
}: Props) {
  const handleChange = (event: MouseEvent<HTMLElement>, newValue?: any) => {
    event.stopPropagation();

    if (!newValue) {
      return;
    }

    onChange(newValue);
  };

  return (
    <StyledToggleButtonGroup
      fullWidth={fullWidth}
      exclusive
      size="small"
      value={value}
      onChange={handleChange}
    >
      {options.map((option) => {
        const content = (
          <StyledToggleButton
            key={option.value}
            sx={slotProps?.optionButton?.sx}
            value={option.value}
            title={option.title}
            disabled={option.disabled}
          >
            {option.label}
          </StyledToggleButton>
        );

        if (option.tooltip) {
          return (
            <Tooltip key={option.value} arrow title={option.tooltip}>
              <div>{content}</div>
            </Tooltip>
          );
        }

        return content;
      })}
    </StyledToggleButtonGroup>
  );
}
